import type { Me } from '@myrewards/contracts';
import { useMatches } from 'react-router';
import type { RootHandle } from '../app/RootLayout';

/**
 * Whether a page exists in this build and this person may open it (APP-054), read from the list
 * Search & jump uses: every route has its entry there, with who can open it. Home offers a link
 * only then, so it never leads to "Page not found" before a page lands, or to a page that would
 * turn the person away (Admin › People is the System Admin's).
 */
export function useCanOpenPage(me: Me, href: string): boolean {
  const root = useMatches().find((match) => match.id === 'root');
  const pages = (root?.handle as RootHandle | undefined)?.searchPages ?? [];
  const page = pages.find((p) => p.href === href);
  return page !== undefined && (page.visible?.(me) ?? true);
}
